<div class="reset-password">
    <h3 class="reset-password-header">Forgot your password?</h3>
    <p class="reset-password-content">
        Enter the email address you used to sign up and we’ll send you an email
        with the instructions for setting a new password.
    </p>
    <form [formGroup]="form" (ngSubmit)="submitForm()" class="reset-form">
        <mat-form-field class="reset-input">
            <input
                matInput
                type="email"
                placeholder="Email"
                formControlName="email"
                [maxlength]="FieldLength.EMAIL_MAX"
                qa="password-reset-email-address-field"
            />
            <mat-error *ngIf="form.get('email').errors?.required"
                >Email is required</mat-error
            >
            <mat-error *ngIf="!form.get('email').errors?.required"
                >Email is invalid</mat-error
            >
        </mat-form-field>
        <div class="login-link">
            <a (click)="backToLogin()" class="bold-text">Back to Login</a>
        </div>
        <div class="reset-button-container">
            <button
                type="submit"
                mat-stroked-button
                class="reset-button ols-mat-stroked-button-color"
                color="primary"
                qa="reset-password-button"
                [disabled]="isSendingEmail"
            >
                <span class="bold-text">{{ getButtonText() }}</span>
                <div *ngIf="isSendingEmail" class="submitting-spinner">
                    <mat-spinner
                        *ngIf="isSendingEmail"
                        [diameter]="25"
                        [strokeWidth]="3"
                    ></mat-spinner>
                </div>
            </button>
        </div>
    </form>
</div>
